import React, { useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { faSave } from '@fortawesome/free-solid-svg-icons';

//Components
import TextField from '../../../components/TextField/TextField';
import TabelaCabecalho from './TabelaCabecalho';

//Helpers
import mascaras from '../../../helpers/mascaras';
import { showQuestion } from '../../../helpers/message';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//Estado inicial do cabeçalho do formulario
function initialStateCabecalho() {
    return {
        sequencia: "",
        identificacao: "",
        tipoValor: null,
        obrigatorio: false,
        opcoes: [],
    }
}
export default function Cabecalho({ formulario, setFormulario, openFormCabecalho, setOpenFormCabecalho }) {
    //Estado de controle dos campos de erro
    const [errors, setErrors] = useState({});

    //Ações da tabela de cabeçalhos
    const actions = [
        actionsTable.editar((rowData) => {
            setErrors({});
            
            setCabecalho(formulario.cabecalhos[rowData.tableData.id]);
            setOpenFormCabecalho(true);
        }),
        actionsTable.remover((rowData) => {
            showQuestion("Tem certeza disso?", "Você tem certeza de que deseja remover este cabeçalho? Esta é uma ação irreversível", "warning", (confirmation) => removerCabecalho(rowData, confirmation))

        })
    ]
    //Função que remove o item da lista
    const removerCabecalho = (cabecalho, confirmacao) => {
        if (confirmacao) {

            setFormulario({
                ...formulario,
                cabecalhos: formulario.cabecalhos.filter(item => item.tableData.id != cabecalho.tableData.id)
            })
            setCabecalho(initialStateCabecalho());
            setOpenFormCabecalho(false);
        }
    }
    //Estado de controle dos dados do formulario do cabecalho
    const [cabecalho, setCabecalho] = useState(initialStateCabecalho);

    //onChange para os campos de texto do formulario de cabeçalho
    const onChangeTexto = (e) => {
        const { name, value } = e.target;
        setCabecalho({
            ...cabecalho,
            [name]: value
        });
    }

    //onChange para o campo de select de tipo de valor
    const onChangeTipoValor = (e, select) => {
        setCabecalho({
            ...cabecalho,
            opcoes: e == null || e.value != "Lista" ? [] : cabecalho.opcoes,
            [select.name]: e != null ? e.value : null
        })
    }

    //OnChange para o checkbox
    const onChangeCheckbox = (e) => {
        const { name, checked } = e.target;
        setCabecalho({
            ...cabecalho,
            [name]: checked
        })
    }

    //OnChange para o campo de opções de resposta
    const onChangeOpcoes = (inputValue) => {
        setCabecalho({
            ...cabecalho,
            opcoes: typeof inputValue === "object" ? [...inputValue] : [...cabecalho.opcoes, { value: inputValue, label: inputValue }]
        });
    }


    //Opções dos selects de tipo de valor
    const optionsTipoValor = [
        { label: "Data", value: "Data" },
        { label: "Lista", value: "Lista" },
        { label: "Número", value: "Número" },
        { label: "Texto", value: "Texto" }
    ]

    //Campos obrigatorios no cadastro de um novo cabeçalho
    const camposObrigatorios = [
        objCampo({ name: "sequencia", required: true }),
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "tipoValor", required: true }),
    ]

    //Função que adiciona um cabeçalho a lista 
    const adicionarCabecalho = () => {
        const _errors = validarCampos(cabecalho, camposObrigatorios);
        setErrors(_errors[0]);
        if (_errors[1].length > 0) {
            return;
        }
        if (cabecalho.tableData) {
            const _cabecalhos = formulario.cabecalhos.map((value, index) => {
                if (cabecalho.tableData.id === index) {
                    return { ...cabecalho };
                }
                return value;
            });
            setFormulario({
                ...formulario,
                cabecalhos: _cabecalhos
            });
        } else {
            setFormulario({
                ...formulario,
                cabecalhos: [...formulario.cabecalhos, { ...cabecalho }]
            });
        }
        setOpenFormCabecalho(false);
        setCabecalho(initialStateCabecalho);
    }

    return (
        <div>
            <div className={`formContainer mb-4 ${openFormCabecalho ? "" : "close"}`}>
                <Row >
                    <Col lg="4">
                        <TextField invalid={!!errors.sequencia} label={"* Sequência"} onChange={onChangeTexto} name={"sequencia"} value={cabecalho.sequencia} mask={mascaras.numeroMask} />
                    </Col>
                    <Col lg="8">
                        <TextField invalid={!!errors.identificacao} label={"* Identificação"} onChange={onChangeTexto} name={"identificacao"} value={cabecalho.identificacao} />
                    </Col>
                    <Col lg="4">
                        <TextField invalid={!!errors.tipoValor} label={"* Tipo de valor"} options={optionsTipoValor} type="select" searchable name={"tipoValor"} value={cabecalho.tipoValor != null ? optionsTipoValor.filter(v => v.value === cabecalho.tipoValor)[0] : null} onChange={onChangeTipoValor} />
                    </Col>
                    <Col lg="4" className='mt-2'>
                        <TextField label={"Campo obrigatório"} type="checkbox" name={"obrigatorio"} onChange={onChangeCheckbox} value={cabecalho.obrigatorio} />
                    </Col>
                    {cabecalho.tipoValor === "Lista" &&
                        <Col lg="12" className='mt-2'>
                            <TextField label={"Opções de resposta"} type="select" creatable name={"opcoes"} onChange={onChangeOpcoes} value={cabecalho.opcoes} />
                        </Col>
                    }
                </Row>
                <div className='w-100 d-flex align-items-center justify-content-center'>
                    <Button color='success' onClick={adicionarCabecalho}><FontAwesomeIcon icon={faSave} /> <span className="fw-bold">Salvar</span></Button>
                </div>
            </div>
            <TabelaCabecalho actions={actions} items={formulario.cabecalhos} />
        </div>
    );
}